/**
 * @file   src\components\CWHeader.tsx
 * @brief  Header component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState, Container, Button, useNavigate, React } from '../utils/thirdpartyComponents';
import Carwashlogoinner from '../assets/images/CarWash-HeaderLogo.svg';
import MainMenu from './MainMenu';
import HamburgerIcon from '../assets/images/icons/hamburger';
import SidebarMenu from './SidebarMenu';
import BackarrowIcon from '../assets/images/icons/backarrow';
import '../components/CWHeader.scss';
import { pageURLs } from '../utils/pageUrls';

// Toast object creation.

const CWHeader = (props: any) => {

  const { data } = props

  const [showSidebarMenu, setShowSidebarMenu] = useState(false);
  const SidebarMenuClose = () => {
    setShowSidebarMenu(false
    )
  };
  const SidebarMenuShow = () => setShowSidebarMenu(true);

  const navigate = useNavigate();

  // On clicking back button
  const handleBackbutton = () => {
    navigate(data.url)
  }

  return (
    <div className="header-fixed-wrap">
      <div className="header-main d-flex align-items-center position-relative">
        <Container className='d-flex align-items-center'>
          <div className="logo" onClick={() => navigate(`/superadmin/${pageURLs.dashboard}`)}><img src={Carwashlogoinner} alt="Dashboard" title="Dashboard" /></div>
          {data.showMainMenu ?
            <div className="main-menu-wrap d-flex align-items-center ms-auto">
              <MainMenu active_menu={data.activeLink} />
              <Button variant="link" onClick={SidebarMenuShow} className="hamburger-menu"><HamburgerIcon /></Button>
            </div>
            : null}
        </Container>
      </div>
      <div className="header-sub d-flex align-items-center">
        <Container>
          <div className="head-title-group d-flex align-items-center">
            {data.showBackButton ? < Button variant="light" className="light-btn" onClick={handleBackbutton} ><BackarrowIcon /></Button> : null}
            <h6 className='fw-bold'>{data.heading}</h6>
          </div>
        </Container>
      </div >
      <SidebarMenu
        show={showSidebarMenu}
        onHide={SidebarMenuClose}
      />

    </div >

  );
};
export default CWHeader;
